var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignHanging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 64H112V24C112 10.8 101.2 0 88 0H88C74.8 0 64 10.8 64 24V64H24C10.8 64 0 74.8 0 88V88C0 101.2 10.8 112 24 112H64V488C64 501.2 74.8 512 88 512H88C101.2 512 112 501.2 112 488V112H192V160C174.25 160 160 174.25 160 192V352C160 369.673 174.327 384 192 384H448C465.673 384 480 369.673 480 352V192C480 174.25 465.75 160 448 160V112H488C501.2 112 512 101.2 512 88V88C512 74.8 501.2 64 488 64ZM432 336H208V208H432V336ZM416 160H224V112H416V160Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignHanging);
export default __webpack_public_path__ + "static/media/sign-hanging.27c0149f5aedc93d2420d462c5d8cdbe.svg";
export { ForwardRef as ReactComponent };